import { clone, cloneDeep } from 'lodash';

export default ['basketApiService', 'storeService', 'messageService', (basketApiService, storeService, messageService) => {
    let basket = {
        contents: {},
        saving: false
    };

    basket.promise = Promise.resolve();

    basket.get = () => {
        let basketCode = storeService.get('basket');
        basket.saving = true;

        if (basketCode === 'undefined'
            || basketCode === 'null') {
            basketCode = null;
            storeService.set('basket', '');
        }

        if (basketCode) {
            return getExistingBasket(basketCode);
        }

        return getNewBasket();
    };

    basket.referenceGenerator = () => {
        let instanceref = '';
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let index = 0; index < 16; index++) {
            instanceref += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return instanceref;
    };

    basket.addToBasket = (guests, item) => {
        basket.success = false;
        basket.saving = false;
        basket.contents.option = 'delete_orders';

        basket.mergeGuests(guests, item);

        return basket.submit();
    };

    basket.mergeGuests = (guests, item) => {
        if (!guests.length || !item) {
            return false;
        }

        item.reference = basket.referenceGenerator();

        guests.forEach(guest => {
            let existingGuest = -1;
            let guestItem = buildGuestItem(item, guest.staff);
            if (guest.item_children) {
                guest.item_children.forEach(child => {
                    guestItem.item_children.push(buildGuestItem(child));
                });
            }

            if (basket.contents.guest_details.length > 0) {
                existingGuest = basket.contents.guest_details.findIndex(basketGuest => {
                    if (guest.id) {
                        return basketGuest.id === guest.id;
                    }

                    return (basketGuest.title ? basketGuest.title === guest.title : true)
                        && basketGuest.first_name === guest.first_name
                        && basketGuest.last_name === guest.last_name;
                });
            }

            if (existingGuest > -1) {
                if (!guest.imported) {
                    basket.contents.guest_details[existingGuest].title = guest.title;
                    basket.contents.guest_details[existingGuest].first_name = guest.first_name;
                    basket.contents.guest_details[existingGuest].last_name = guest.last_name;
                }

                basket.contents.guest_details[existingGuest].item_details.push(guestItem);
                return;
            }

            guest.item_details = [guestItem];
            basket.contents.guest_details.push(guest);
        });
    };

    basket.submit = (action = 'add') => {
        return basketApiService.submitBasket(basket.contents)
            .then(response => {
                if (response.basket_status && response.basket_status !== '-1') {
                    basket.contents = response;

                    if (response.errors && response.errors.length) {
                        basket.success = false;
                        errorHandler({}, action);
                        return;
                    }

                    basket.success = true;
                    return;
                }

                basket.success = false;
            })
            .catch(error => {
                basket.success = false;

                if (error.status === 404) {
                    errorHandler(error, 'get', true);

                    return basket.get();
                }

                errorHandler(error, action);
            })
            .then(() => {
                basket.saving = false;
            });
    };

    basket.isEmpty = () => {
        return !!(basket.contents.guest_details
            && !basket.contents.guest_details.find(guest => {
                return guest.item_details.length > 0;
            }));
    };


    const getExistingBasket = (basketCode) => {
        return basketApiService.retrieveBasket(basketCode)
            .then(response => {
                if (response) {
                    basket.contents = response;
                }

                basket.saving = false;
            })
            .catch(error => {
                storeService.set('basket', '');

                if (error.status === 410) {
                    errorHandler(error, 'complete');
                }

                if (error.status === 400 || error.status === 404) {
                    errorHandler(error, 'get', true);
                }

                return basket.get();
            });
    };

    const getNewBasket = () => {
        return basketApiService.generateBasket()
            .then(response => {
                if (response && response.id && response.basket) {
                    storeService.set('basket', response.id);
                    basket.contents = response.basket;
                }

                basket.saving = false;
            })
            .catch(error => {
                errorHandler(error, 'create');

                return basket.get();
            });
    };

    const errorHandler = (error, callType, checkData = false) => {
        let errorMessages = {
            add: 'There was a problem adding that item to the basket',
            complete: 'Your previous basket is already completed, starting a fresh one',
            create: 'There was an error creating the basket, starting a fresh one',
            expired: 'Sorry, your previous basket has expired, starting a fresh one',
            get: 'There was an error retrieving the basket, starting a fresh one',
            remove: 'There was a problem removing that, please try again',
        };

        let errorMessage = errorMessages[callType];

        if (checkData) {
            switch (error.data) {
                case 'expired':
                    errorMessage = errorMessages.expired;
                    break;
                case 'not_found':
                    errorMessage = errorMessages.get;
                    break;
                case 'basket_ordered':
                    errorMessage = errorMessages.complete;
                    break;
            }
        }

        messageService.failure(errorMessage);
        if (basket.contents.errors && basket.contents.errors.length > 0) {
            basket.contents.errors.forEach(error => {
                messageService.failure(error);
            });
        }
        messageService.push();

        if (checkData && error.data !== 'expired') {
            messageService.autoClear();
        }
    };

    const buildGuestItem = (item, staff) => {
        if (typeof item.price === 'object') {
            item.original_price = item.price.original_price;
            item.price = item.price.price;
        }

        if (item.offer && typeof item.offer === 'object') {
            item.offer_id = item.offer.id;
        }

        let guestItem = Object.assign({}, item, {
            id: null,
            reference: item.reference || basket.referenceGenerator(),
            item_id: item.id,
            name: item.name.replace('/\\/g', ''),
            price: item.price || 0,
            original_price: item.original_price || 0,
            currency: basket.contents.currency,
            upgraded: item.upgraded || 0,
            item_type: item.type_raw || `App\\${item.type_name}`,
            item_children: []
        });

        if (staff) {
            guestItem.integration_staff = staff.id;
            guestItem.integration_staff_name = staff.label;
        }

        if (item.group_id) {
            guestItem.item = {
                'option_group_id': item.group_id,
                'option_type': item.option_type,
                'option_id': item.option_id
            };
        }

        return guestItem;
    };

    return basket;
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/services/basket.service.js